/** @license Guesty v3.3.5
 *
 * This source code is licensed under the ISC license found in the
 * LICENSE file in the root directory of this source tree.
 */
import { // FormattedDate, // TODO: After we will deprecated moment, move to the react-intl based components for date and time formatting
// FormattedTime, // TODO: Wrap in our own component folder
FormattedRelativeTime } from 'react-intl';
import intl from "./intl/intl";
import useIntl from "./useIntl/useIntl";
import useLocale from "./hooks/useLocale";
import dayjs from "./dayjs-config";
import LocalizationProvider from "./LocalizationProvider";
import LocalizationContext from "./LocalizationProvider/LocalizationContext";
import FormattedMessage from "./FormattedMessage";
import FormattedTime from "./FormattedTime";
import FormattedDate from "./FormattedDate";
import FormattedCurrency from "./FormattedCurrency";
import FormattedNumber from "./FormattedNumber";
import Moment from "./Moment";
import { useFormattedDate, useFormattedDatesArray } from "./hooks/useFormattedDate";
import usePreferences from "./hooks/usePreferences";
import { useFormattedNumber, createFormattedNumber } from "./hooks/useFormattedNumber";
export { intl, useIntl, useLocale, dayjs, LocalizationProvider, LocalizationContext, FormattedMessage, FormattedNumber, FormattedCurrency, FormattedDate, FormattedTime, FormattedRelativeTime, Moment, useFormattedDate, useFormattedDatesArray, usePreferences, useFormattedNumber, createFormattedNumber };